# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/

window.toggleSelectExtraField = (element, accessor) ->
  if(element.value == "-1")
    $(accessor).collapse('show')
  else
    $(accessor).collapse('hide')

window.check_copying_finished = ()->
  clearInterval(window.copyStatusIntervalID) if window.copyStatusIntervalID?

  updateCourseCopyProgress = (course_id, response)->
    progress = Math.max(0, Math.min(100, parseInt(response["progress"], 10) || 0))
    message = response["message"] || "Copying course"
    completed = response["completed"]
    total = response["total"]
    progress_container = $(".course-copy-progress[data-course-id='" + course_id + "']")

    progress_container.find("[data-course-copy-message]").text(message)
    progress_container.find("[data-course-copy-progress-bar]").css({
      "width": progress + "%",
      "background-color": courseCopyProgressColor(progress)
    })
    progress_region = progress_container.find("[role='progressbar']")
    progress_region.attr("aria-valuenow", progress)
    progress_region.attr("aria-valuetext", message + " " + progress + "%")

    if total? && total > 0
      progress_container.find("[data-course-copy-counts]").text(completed + "/" + total)
    else
      progress_container.find("[data-course-copy-counts]").text("")

  courseCopyProgressColor = (progress)->
    percent = Math.max(0, Math.min(100, progress)) / 100
    start_color = [58, 179, 231]
    end_color = [46, 133, 64]
    rgb = start_color.map((start_value, index)->
      Math.round(start_value + ((end_color[index] - start_value) * percent))
    )
    "rgb(" + rgb.join(", ") + ")"

  replaceCourseCopyRow = (course_id, response)->
    row = $("#Course_" + course_id)
    if row.length && response["row_html"]?
      row.replaceWith(response["row_html"])
      $('[data-bs-toggle="tooltip"]').tooltip()
    else
      location.reload()

  animateSuccessfulCourseCopy = (course_id, response)->
    row = $("#Course_" + course_id)
    return location.reload() unless row.length && response["row_html"]?
    return if row.data("course-copy-completing")

    row.data("course-copy-completing", true)
    row.addClass("course-copy-complete")
    updateCourseCopyProgress(course_id, {
      "progress": 100,
      "message": row.find("[data-course-copy-message]").text(),
      "completed": response["completed"],
      "total": response["total"]
    })

    progress_container = row.find(".course-copy-progress")
    progress_region = progress_container.find("[role='progressbar']")
    progress_region.attr("aria-valuenow", 100)
    progress_region.attr("aria-valuetext", "Course copy complete 100%")

    icon_slot = row.find(".course-copy-completion-icon-slot")
    icon_slot.html("<span class='course-copy-complete-check' aria-hidden='true'>✓</span><span class='visually-hidden'>Course copy complete</span>")

    setTimeout(()->
      replaceCourseCopyRow(course_id, response)
    , 1200)

  responseFinished = (response)->
    response["terminal"] == true || response["response"]["response_code"] != "in_progress"

  responseSucceeded = (response)->
    response["response"]["response_code"] == "success"

  pollCourseCopies = ->
    progress_containers = $(".course-copy-progress[data-course-id]")

    if progress_containers.length == 0
      clearInterval(window.copyStatusIntervalID)
      return

    progress_containers.each ->
      course_id = $(this).data("course-id")
      $.ajax "/courses/" + course_id + "/check_copy_status",
        type: "get",
        dataType: "json",
        success: (response)->
          if responseFinished(response)
            if responseSucceeded(response)
              animateSuccessfulCourseCopy(course_id, response)
            else
              replaceCourseCopyRow(course_id, response)
          else
            updateCourseCopyProgress(course_id, response)
        error: ->
          location.reload()

  pollCourseCopies()
  window.copyStatusIntervalID = setInterval(pollCourseCopies, 1500)

  # Clears interval when page changes
  $(document).on 'turbolinks:before-cache turbolinks:before-render', ->
    clearInterval(window.copyStatusIntervalID)


window.submitCopyCourse = () ->
  $.ajax "/courses/" + in_progress_course_id + "/check_copy_status",
    type: "get",
    dataType: "json",
    success: (response)->
      if(response["terminal"] == true || response["response"]["response_code"] != "in_progress")
        clearInterval(window.copyStatusIntervalID)
        location.reload()

# Checks to see if the copy popup should be rendered on page load.
window.showCopyPopupFromShareLink = () ->
  if($("input[id='share_course_id']").length > 0 && $("input[id='share_course_token']").length > 0)
    course_id = $("input[id='share_course_id']").val()
    course_token = $("input[id='share_course_token']").val()
    $.ajax "/courses/" + course_id + "/share_copy_popup?t=" + course_token,
      type: "get"
      dataType: 'script'
      error: (xhr, status, error)->
        console.log(xhr.responseText)


$(document).on "turbolinks:load", ->

  $(".sortable").vbSortable({
    items: "> *:not(.sortable-ignore)",
    placeholder: "course-sortable-placeholder"
  })

  if !window.location.pathname.includes("manage_roster") && !window.location.search.includes("inactive") && !window.location.search.includes("commit=Search") || !window.location.pathname.includes("grades") && !window.location.search.includes("inactive") && !window.location.search.includes("commit=Search")
    sessionStorage.setItem('inSecondView',false)
    if sessionStorage.getItem('stayInArchive')
      sessionStorage.setItem('inSecondView',true)
      sessionStorage.removeItem('stayInArchive');
  toggleOptions = (inSecondView) ->
    if inSecondView
#      if ($('#my_archive_page').is(":hidden"))
        $('#my_archive_page').show()
        $('#my_courses_page').hide()
        $('#first_option_table').hide()
        $('#second_option_table').show()
        $('#first_option_count').hide()
        $('#second_option_count').show()
        swap_button_colors("second_option_toggled")
        sessionStorage.setItem('inSecondView', true)
    else
#      if ($('#my_courses_page').is(":hidden"))
        $('#my_archive_page').hide()
        $('#my_courses_page').show()
        $('#second_option_table').hide()
        $('#first_option_table').show()
        $('#second_option_count').hide()
        $('#first_option_count').show()
        swap_button_colors("first_option_toggled")
        sessionStorage.setItem('inSecondView', false)
    return false

  swap_button_colors = (selected) ->
    if selected == "first_option_toggled"
      $('#first_option_toggle').addClass("rounded")
      $('#first_option_toggle').removeClass("bg-white")
      $('#first_option_toggle').addClass("active-toggle")
      $('#first_option_toggle').removeClass("text-muted")
      $('#first_option_toggle').addClass("text-info")
      $('#second_option_toggle').removeClass("rounded")
      $('#second_option_toggle').removeClass("active-toggle")
      $('#second_option_toggle').addClass("bg-white")
      $('#second_option_toggle').removeClass("text-info")
      $('#second_option_toggle').addClass("text-muted")
    else if selected == "second_option_toggled"
      $('#second_option_toggle').removeClass("text-muted")
      $('#second_option_toggle').removeClass("bg-white")
      $('#second_option_toggle').addClass("rounded")
      $('#second_option_toggle').addClass("active-toggle")
      $('#second_option_toggle').addClass("text-info")
      $('#first_option_toggle').addClass("bg-white")
      $('#first_option_toggle').removeClass("text-info")
      $('#first_option_toggle').addClass("text-muted")
      $('#first_option_toggle').removeClass("rounded")

  $(document).off("click.coursesToggleActive", "#my_courses_link, #first_option_toggle")
  $(document).on("click.coursesToggleActive", "#my_courses_link, #first_option_toggle", (e) ->
    url = new URL(location);
    $('.popover').addClass('show');

    if !url.search.includes('page=1') && url.search.includes('toggle') && url.search.includes('page')
      url.searchParams.set('toggle', 'active');
      url.searchParams.set('page', "1");
      window.location.replace(url)
    toggleOptions(false);
    $(".alert").alert('close');
  )

  $(document).off("click.coursesStayArchive", "#make-active-button, .make-active-button")
  $(document).on("click.coursesStayArchive", "#make-active-button, .make-active-button", (e) ->
    if $('div#second_option_table').has(e.currentTarget).length > 0
      sessionStorage.setItem('stayInArchive', true)
  )

  $(document).off("click.coursesToggleArchive", "#my_archive_link, #second_option_toggle")
  $(document).on("click.coursesToggleArchive", "#my_archive_link, #second_option_toggle", (e) ->
    url = new URL(location);
    $('.popover').removeClass('show');

    if !url.search.includes('page=1') && url.search.includes('toggle') && url.search.includes('page')
      url.searchParams.set('toggle', 'inactive');
      url.searchParams.set('page', "1");
      window.location.replace(url)
    toggleOptions(true);
    $(".alert").alert('close');
  )

  if sessionStorage.getItem('inSecondView') == 'true'
    toggleOptions(true)
  else
    toggleOptions(false)

  $(".course-form-collapse-select").on("change", (e) ->
    e.preventDefault()
    toggleSelectExtraField(this, "#groupNameField_" + $(this).attr("dataCID"))
  )
  
  $("#copy-course-code-btn").on("click", (e) ->
    e.preventDefault()
    copyTextStatus = $("#copy-course-status")
    copyTextarea = $("#copy-course-code-field")
    targetID = "#" + "#{e.currentTarget.id}"
    navigator.clipboard.writeText(copyTextarea.val())
      .then ->
        $(targetID).attr('data-bs-original-title', '✓ Copied to clipboard!').tooltip('show')
    setTimeout ->
      $(targetID).attr('data-bs-original-title', '').tooltip('hide')
    , 2000
    copyTextStatus.html("Link Copied!")
  )
  
  $("#course-share-popup").on('show.bs.modal', (e) ->
    $(this).find(".modal-body #copy-course-code-field").val($(e.relatedTarget).data("url"))
  )
  
  # Default to the first time zone that matches the current UTC offset
  $(".time-zone-select-current").val($(".time-zone-select-current option[data-bs-offset="+ (-(new Date().getTimezoneOffset())) + "]").first().val())
  
  # Enable tooltips for this page
  $('[data-bs-toggle="tooltip"]').tooltip()

  $(".ctx_field").on("keyup", (e) ->
    $("#save_" + this.parentNode.parentNode.id).attr("disabled", false)
  )

  # Enable 'other' time extension input
  $(".tx_select").on("change", (e) ->
    $("#save_" + this.id).attr("disabled", false)
    if (this.value <= -2.0)
      $("#custom_tx_" + this.id).attr("disabled", false)
    else
      $("#custom_tx_" + this.id).attr("disabled", true)
  )

  check_copying_finished()
  showCopyPopupFromShareLink()

# This triggers the restricted course pop up if someone is shared a course via url they don't have access to
  $("#course-restriction-popup").modal("show")

  # Focus on table header during sort
  # Get the url
  url = new URL(location);
  # Check if url params contains a direction for sort
  if url.search.includes('direction=asc') || url.search.includes('direction=desc')
    # If it does then focus on the current sort
    $('.current').focus()
